<template>
  <div>
    <div style="text-align: center" @click="setLimit(limitData)">
      <jd-button
        :disabled="limitBtnDisabled || !limitData[totalAmountKey]"
        v-if="!limitData.dailyLimitType && !limitData.dailyLimit"
        type="blueText"
      >
        配置
      </jd-button>
      <jd-button
        :disabled="limitBtnDisabled"
        v-if="limitData.dailyLimitType == 0 && limitData.dailyLimit"
        type="blueText"
      >
        每日发放{{ limitData.dailyLimit }}份
      </jd-button>
      <div v-if="limitData.dailyLimitType == 1">
        <div>
          <jd-button :disabled="limitBtnDisabled" type="blueText"
            >闲时发放{{ limitData.idleLimit }}份</jd-button
          >
        </div>
        <div>
          <jd-button :disabled="limitBtnDisabled" type="blueText"
            >忙时发放{{ limitData.busyLimit }}份</jd-button
          >
        </div>
      </div>
    </div>
    <!-- 每日发放限额弹窗 -->
    <setLimitDialog
      :visible.sync="showLimitDialog"
      :init-data="limitData"
      :backgroundOpacity="backgroundOpacity"
      :totalAmountKey="totalAmountKey"
      @confirm="handleLimitConfirm"
    />
  </div>
</template>

<script>
import setLimitDialog from "@/views/interactiveMarketing/activity/components/_components/setLimitDialog.vue";
export default {
  name: "dailyLimitConfig",
  model: {
    prop: "row",
    event: "rowUpdate",
  },
  components: {
    setLimitDialog,
  },
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
    // 是否允许编辑每日发放限额
    limitBtnDisabled: {
      type: Boolean,
      default: false,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    // 奖品总数字段名
    totalAmountKey: {
      type: String,
      default: "totalAmount",
    },
  },
  computed: {
    limitData: {
      get: function () {
        return this.row;
      },
      set: function (val) {
        this.$emit("rowUpdate", val);
      },
    },
  },
  data() {
    return {
      showLimitDialog: false,
    };
  },
  methods: {
    // 每日发放限额弹窗
    setLimit(row) {
      if (!row[this.totalAmountKey]) {
        return this.$message.warning("请先输入奖品总数");
      }
      this.showLimitDialog = true;
      this.limitData = row;
    },
    // 每日发放限额弹窗确认
    handleLimitConfirm(data) {
      this.$set(this.limitData, "dailyLimitType", data.dailyLimitType);
      this.$set(this.limitData, "dailyLimit", data.dailyLimit);
      this.$set(this.limitData, "idleLimit", data.idleLimit);
      this.$set(this.limitData, "busyLimit", data.busyLimit);
      if (data.dailyLimitType == 0) {
        // 每日发放
        this.$delete(this.limitData, "idleLimit");
        this.$delete(this.limitData, "busyLimit");
      } else if (data.dailyLimitType == 1) {
        // 按闲忙时配置数量
        this.$delete(this.limitData, "dailyLimit");
      }
    },
  },
};
</script>

<style></style>
